export default __webpack_public_path__ + "static/1-d8333328a30c55168c79c03566ee3ba9.jpg";